import { render, staticRenderFns } from "./BoxMakingTime_Component.vue?vue&type=template&id=22bf5a64&scoped=true&"
import script from "./BoxMakingTime_Component.vue?vue&type=script&lang=js&"
export * from "./BoxMakingTime_Component.vue?vue&type=script&lang=js&"
import style0 from "./BoxMakingTime_Component.vue?vue&type=style&index=0&id=22bf5a64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf5a64",
  null
  
)

export default component.exports